import React from "react";

function EventsLoadingState() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-slate-50 px-4 pb-16 pt-28 font-satoshi dark:bg-slate-950 sm:px-6 lg:px-8">
      <div className="absolute inset-x-0 top-0 h-80 bg-slate-950" />

      <section className="relative mx-auto max-w-7xl">
        <div className="mb-7 h-36 animate-pulse rounded-[2rem] bg-white/10" />

        <div className="mb-6 grid gap-4 sm:grid-cols-3">
          {[1, 2, 3].map((item) => (
            <div
              key={item}
              className="h-28 animate-pulse rounded-[1.5rem] bg-white shadow-sm dark:bg-white/[0.06]"
            />
          ))}
        </div>

        <div className="grid gap-5 lg:grid-cols-2">
          {[1, 2, 3, 4].map((item) => (
            <div
              key={item}
              className="h-80 animate-pulse rounded-[2rem] bg-white shadow-xl dark:bg-white/[0.06]"
            />
          ))}
        </div>
      </section>
    </main>
  );
}

export default EventsLoadingState;